import { useTranslate } from "@pankod/refine-core";

import {
  Create,
  Drawer,
  DrawerProps,
  Form,
  FormProps,
  Input,
  // InputNumber,
  Radio,
  // Select,
  // SelectProps,
  // Space,
  ButtonProps,
  // Avatar,
  // Typography,
  // Upload,
  Grid, Select, useSelect,
  // getValueFromEvent,
  // useSelect,
} from "@pankod/refine-antd";
import {ICategory} from "../../interfaces";

// import { IOrganization } from "interfaces";

// const { Text } = Typography;

type CreateCategoryProps = {
  drawerProps: DrawerProps;
  formProps: FormProps;
  saveButtonProps: ButtonProps;
};

export const CreateCategory: React.FC<CreateCategoryProps> = ({
  drawerProps,
  formProps,
  saveButtonProps,
}) => {
  const t = useTranslate();
  const breakpoint = Grid.useBreakpoint();
  const { selectProps: categorySelectProps } = useSelect<ICategory>({
    resource: "categories",
  });

  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? "500px" : "100%"}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
      // closable={false}
    >
    {/* <Create resource="profilea" saveButtonProps={saveButtonProps}> */}
      <Create saveButtonProps={saveButtonProps}>
        <Form
          {...formProps}
          layout="vertical"
          initialValues={{
            isActive: true,
          }}
        >
          <Form.Item
            label={t("categories.fields.title")}
            name="title"
            rules={[
              {
                required: true,
              },
            ]}
          >
          <Input />
          </Form.Item>
          <Form.Item
              label={t("categories.fields.parent_id")}
              // name={["organizationId", "id"]}
              name="parent_id"
          >
            <Select {...categorySelectProps} />
          </Form.Item>
          <Form.Item label={t("categories.fields.isActive")} name="isActive">
            <Radio.Group>
              <Radio value={true}>{t("status.enable")}</Radio>
              <Radio value={false}>{t("status.disable")}</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Create>
    </Drawer>
  );
};
